import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import {
  API_METHOD_POST,
  API_UPDATE_PHASE_BODY,
} from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface UpdatePhaseNameRequest {
  name: string;
}

export interface UpdatePhaseNameResponse {
  status: 'SUCCESS' | 'FAILED';
  data: {
    id: string;
    title: string;
    description: string | null;
    created_at: string;
    updated_at: string;
  };
  message: string;
}

export const updatePhaseNameFromAPI = async (
  phaseUuid: string,
  data: UpdatePhaseNameRequest,
): Promise<UpdatePhaseNameResponse> => {
  try {
    const method: Method = API_METHOD_POST;
    const url = API_UPDATE_PHASE_BODY(phaseUuid);

    // Convert JSON object to string for hash generation
    const jsonString = JSON.stringify(data);
    const additionalHeaders = {
      hash: generateHash(jsonString),
    };

    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response;
  } catch (error) {
    console.error('Error updating phase name:', error);
    throw error;
  }
};
